<template>
  <div id="app">
    <router-view />
    <div class="wp_pop">
      <div class="wp_content">
        <div class="wp_pop_img"></div>
        <p class="wp_tips">Please rotate your phone for the best browsing experience</p>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    setSessionStorage,
    getSessionStorage,
    loadStyle,
    deleteUrlParam
  } from '@/utils/assist'
  export default {
    data() {
      return {}
    },
    methods: {
      cacheQueryData() {
        // NOTE `PROJECT_NAME` is defined via webpack DefinePlugin
        let { access_token = '', lang = '', region = '' } = this.$route.query
        access_token && setSessionStorage(`${PROJECT_NAME}AccessToken`, access_token)
        lang && setSessionStorage(`${PROJECT_NAME}Lang`, lang)
        region && setSessionStorage(`${PROJECT_NAME}Region`, region)
      },
      getCSS() {
        let region = getSessionStorage(`${PROJECT_NAME}Region`) || ''
        let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
        loadStyle(`/api/css?region=${region}&lang=${lang}`)
      }
    },
    created() {
      this.cacheQueryData()
      this.getCSS()
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue